import { gql } from '@apollo/client';

export const UPDATE_ADMIN = gql`
    mutation ($id: String!, $input: UpdateAdminDTO!) {
        updateAdmin(id: $id, input: $input) {
            message
            admin {
                _id
                name
                email
                status
                role
                phone
                tags
                signature
            }
        }
    }
`;

export const SET_ADMIN_ACTIVE = gql`
    mutation ($id: String!, $active: Boolean!) {
        setAdminActive(id: $id, active: $active) {
            message
            admin {
                _id
                status
            }
        }
    }
`;

export const RESEND_ADMIN_INVITE = gql`
    mutation ($id: String!) {
        resendAdminInvite(id: $id) {
            message
        }
    }
`;

export const SET_ADMIN_CAN_LOGIN = gql`
    mutation ($id: String!, $canLogin: Boolean!) {
        setAdminCanLoginToBusinesses(id: $id, canLogin: $canLogin) {
            message
            admin {
                _id
                canLoginToBusinesses
            }
        }
    }
`;

export const ADD_ADMIN_NOTE = gql`
    mutation ($input: AddAdminNoteInput!) {
        addAdminNote(input: $input) {
            _id
            body
            authorId
            authorName
            isPinned
            createdAt
            updatedAt
        }
    }
`;

export const DELETE_ADMIN = gql`
    mutation ($id: String!) {
        removeAdmin(id: $id) {
            message
            admin {
                _id
            }
        }
    }
`;
